export class ListZeroEtlJobsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "data",
            "baseName": "data",
            "type": "Array<ZeroEtlJob>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListZeroEtlJobsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
